// extracted by mini-css-extract-plugin
module.exports = {"address-details":"AddressDetails_address-details__2MoRi"};